<template>
  <v-dialog
    v-model="copyOfferDialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    width="500"
  >
    <v-card>
      <v-card-title class="text-h5">
        Kopioi tarjous?
      </v-card-title>
      <v-card-text>
        <p class="mb-6">
          Luo uusi tarjous kopioidun tarjouksen pohjalta.
          Huom! Tämä kopioi vain alkuperäisen tarjouksen sisällön.
          Vastauksia ja allekirjoituksia ei kopioida.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn text>
          Peruuta
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="copyOffer()"
        >
          Kopioi
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { apiPost } from '../../api';

export default {
  name: 'CopyOfferDialog',
  props: {
    copyOfferDialog: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    async copyOffer() {
      this.$bus.$emit('SHOW_GLOBAL_LOADER', 'Kopioidaan tarjous');
      const response = await apiPost(`properties/copyoffer/${this.$route.params.offerId}`);
      const params = {
        companyId: this.$route.params.companyId,
        id: this.$route.params.id,
        offerId: response.offerId,
      };
      this.$router.push({ name: 'offer', params });
      this.$bus.$emit('CLOSE_COPY_OFFER_DIALOG');
      this.$bus.$emit('RELOAD_OFFER');
    },
  },
};
</script>
